const baseURL = "/v1/Notificacao";

const service = {
  methods: {
    $buscarGrupoNotificacoes(params) {
      return this.$api().get(`${baseURL}`, params);
    },
    $cadastrarGrupoNotificacao(body) {
      return this.$api().post(`${baseURL}`, body);
    },
    $visualizarGrupoNotificacao(id) {
      return this.$api().get(`${baseURL}/${id}`);
    },
    $editarGrupoNotificacao(body, id) {
      return this.$api().put(`${baseURL}/${id}`, body);
    },
  },
};

export default service;
